export default "__VITE_ASSET__0NBro3PL__"